import SignupForm from "../components/SignupForm/SignupForm";
import "../styles.css/signup-page.css";

export default function Signup() {
  return (
    <div className="login-main">
      <SignupForm />
    </div>
  );
}
